import { call, put } from 'redux-saga/effects';
import { setAbandonedCart } from './index';
import { fetchAbandonedCartByBps } from '../../../services/MVP/abandonedCartApi';
import { AbandonedCartData } from './types';

interface IFetchAbandonedCartAction {
  type: string;
  payload: { bps: string[] };
}

export function* fetchAbandonedCartSaga(action: IFetchAbandonedCartAction) {
  const { bps } = action.payload;
  if (bps.length === 0) return;

  const result: AbandonedCartData | null = yield call(
    fetchAbandonedCartByBps,
    bps
  );
  if (!result) return;
  if (result.notification.notify1 && result.notification.notify2) return;

  yield put(setAbandonedCart(result));
}
